require('./impromptu');
let form = require('../form/form');
import { YandexSmartCaptcha } from '../../modules/YandexSmartCaptcha/yandex-smart-captcha';
jQuery(function() {
    var addCommentFormHtml = $('.js-review-add_container').html();

    new YandexSmartCaptcha('articles_comments_captcha').init();

    var addCommentPrompt = {
        addComment: {
            html: addCommentFormHtml,
            submit: function(e, v, m) {
                e.preventDefault();
                var $params = $.extend({}, form.formValidateDefaults, {
                    rules: {
                        review_name: { required: true },
                        review_city: { required: true },
                        review_rating: {},
                        review_comment: {}
                    },
                    messages: {
                        review_name: { required: 'Не указано имя' },
                        review_city: { required: 'Не указан город' }
                    },
                    submitHandler: function() {
                        $.ajax({
                            type: 'POST',
                            url: '/ajax/action/reviews/add/',
                            data: $('form.jqiform').serializeArray(),
                            success: function(result) {
                                $.prompt
                                    .getState('addComment')
                                    .find('.form')
                                    .html('<p>' + result.html + '</p>');
                            }
                        });
                        $.prompt.position();
                    }
                });
                var $form = m.closest('form');
                $form.validate($params);
            }
        }
    };

    $(document).on('click', '.js-jqi-add-comment', function(e) {
        e.preventDefault();
        $.prompt(addCommentPrompt);
    });
});



// WEBPACK FOOTER //
// ./blocks/impromptu/impromptu-comment.js